import React from "react";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";

// data-bs-toggle="modal"
//data-bs-target="#m-"

export const Modal = (props) => {
  return (
    <div
      className="modal fade"
      id={props.id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{props.title}</h5>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span className="svg-icon svg-icon-1 ">
                <svg
                  xmlns="http://www.w3.org/2000/svg "
                  width="24 "
                  height="24 "
                  viewBox="0 0 24 24 "
                  fill="none "
                >
                  <rect
                    opacity="0.5 "
                    x="6 "
                    y="17.3137 "
                    width="16 "
                    height="2 "
                    rx="1 "
                    transform="rotate(-45 6 17.3137) "
                    fill="currentColor "
                  ></rect>
                  <rect
                    x="7.41422 "
                    y="6 "
                    width="16 "
                    height="2 "
                    rx="1 "
                    transform="rotate(45 7.41422 6) "
                    fill="currentColor "
                  ></rect>
                </svg>
              </span>
            </div>
          </div>
          <div className="modal-body">
          {props.children}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
